import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import {
  NavBar,
  LoadingScreen,
  Footer,
  NotFound,
  AnalysisUser,
} from "../../components";
import IndexedDBManager from "../../DB/indexDB";
import configuration from "../../../package.json";

export const Home = (props) => {
  const params = useParams();
  const { homepage, version, indexedDB } = configuration;
  const [partsList, setPartsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cover, setCover] = useState(undefined);
  const [NotfoundData, setNotfoundData] = useState(false);
  const [main, setMain] = useState([]);
  const [file, setFile] = useState(null);
  
  useEffect(() => {
    loadData();
  }, [params]);


  const constGetLocalImage = async (id) => {
    let image = homepage + "images/" + id;
    const dbManager = new IndexedDBManager(indexedDB, "images", version);
    await dbManager.openDatabase().then(async () => {
      await dbManager.getData(image).then((result) => {
        if (result) {
          setCover(image);
        } else {
          LoadImages(image);
          setCover(image);
        }
      });
    });
    return image;
  };

  const LoadImages = (image) => {
    const dbManager = new IndexedDBManager(indexedDB, "images", version);
    [image].map((image) =>
      convertAudioToBase64(image).then(async (base64Data) => {
        await dbManager
          .openDatabase()
          .then(async () => {
            await dbManager
              .addData({ id: image, data: base64Data })
              .then(async (result) => {})
              .catch((e) => {});
          })
          .catch((error) => {
            setCover(image);
          });
      })
    );
  };

  function convertAudioToBase64(url) {
    return fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
  }

  const loadData = async () => {
    try {
      // Load manifest.json instead of manifest.json
      const manifestRes = await axios.get(`${homepage}data/manifest.json`);
      const { manifest } = manifestRes.data; // Direct JSON parsing
      
      const currentData = manifest.items.filter(
        (item) =>
          item.subject == params.subject &&
          item.grade == params.grade &&
          item.content == "dictionary"
      );
      
      if (currentData.length > 0) {
        setMain({
          year: params.year
            ? params.year
            : currentData[currentData.length - 1].year,
          version: params.version
            ? params.version
            : currentData[currentData.length - 1].version,
        });
        
        // Get the JSON file name instead of YAML
        const jsonFileName = params.version
          ? `v${params.version}.json`
          : `${currentData[currentData.length - 1].json}.json`;
        
        setFile(jsonFileName);
        
        // Load content JSON file instead of YAML
        const contentRes = await axios.get(`${homepage}data/${jsonFileName}`);
        const { parts, metadata } = contentRes.data; // Direct JSON parsing
        
        console.log(contentRes)

        constGetLocalImage(metadata.cover_image);
        setPartsList(parts);
      } else {
        setNotfoundData(true);
      }
    } catch (error) {
      setNotfoundData(true);
    } finally {
      setLoading(false);
    }
  };

  const PageRender = ({
    index,
    title,
    kind,
    items,
    sections,
    header,
    images,
    sound,
    srt,
  }) => {
    return (
      <>
        <Link
          to={`/dict/${params.stage}/${params.subject}/${params.grade}/${main.year}/${main.version}/${kind}`}
          hash={title}
          state={{ title, kind, items, sections, header, images, sound, srt }}
          className="flex w-full flex-row gap-[2px]"
        >
          <div className="flex bg-company-red w-14 whitespace-nowrap leading-[30px] text-center text-white p-1 border rounded-l-lg text-lg font-semibold items-center justify-center">
            {index}
          </div>
          <div className="flex bg-white text-gray-700 w-full leading-[30px] p-1 border rounded-r-lg text-lg font-semibold items-center justify-start">
            {title.phrase}
          </div>
        </Link>
      </>
    );
  };

  return (
    <div className="flex w-full max-w-screen h-fit min-h-screen p-0 m-0 flex-col gap-2 overflow-hidden md:max-w-[875px] md:m-auto relative">
      {file ? <AnalysisUser file={file} app={"dict"} /> : <></>}
      <NavBar
        logo="logo_3.svg"
        home={false}
        grade="3"
        extention="rd"
        main="Prep."
        search={true}
      />
      <LoadingScreen active={loading} />
      <div className="flex flex-col w-full top-14 sm:top-16 relative">
        {cover != null ? (
          <img
            alt="book cover"
            src={`${cover}`}
            className="h-auto bg-white w-full pt-4"
          />
        ) : (
          <></>
        )}
        {NotfoundData ? <NotFound /> : <></>}
        <div className="p-2 gap-2 flex sm:grid flex-col mt-3">
          {partsList.map((part, index) => (
            <PageRender key={index} index={index + 1} {...part} />
          ))}
        </div>
      </div>
      <div className="h-24" />
      <Footer />
    </div>
  );
};